import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Position } from './position';
import { RequestOptions, Headers } from '@angular/http';
import { baseAPI, baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class PositionService {

  private url = baseUrl + gatewayFile;

  positions: Position[];

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getPositions(site: string, date: string): Observable<Position[]> {
    const url = `${this.url}`;
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'getPositions', item1: site, item2: date })
    .pipe(
      catchError(this.handleError('getPositions', []))
    );
  }

  addPosition(
    site: string,
    date: string,
    shift: string,
    startTime: string,
    endTime: string,
    createdBy: string,
    isFilled: string,
    requirement: number = 0,
    workArea: string = ''
  ): Observable<Position[]> {
    return this.http.post<Position[]>(
      this.url,
      {
        token: localStorage.getItem('token'),
        function: 'addPosition',
        item1: site,
        item2: date,
        item3: shift,
        item4: startTime,
        item5: endTime,
        item6: createdBy,
        item7: isFilled,
        requirement,
        workArea
      }
    )
    .pipe(
      catchError(this.handleError('addPosition', []))
    );
  }

  removePosition(itemId): Observable<Position[]> {
    const url = `${this.url}`;
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'removePosition', item1: itemId })
    .pipe(
      catchError(this.handleError('removePosition', []))
    );
  }

  updatePositionFilled(positionId: string, isFilled: string, startTime: string, endTime: string, createdBy: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'updatePositionFilled',
      item1: positionId, item2: isFilled, item3: startTime, item4: endTime, item5: createdBy})
    .pipe(
      catchError(this.handleError('updatePositionFilled', []))
    );
  }

  setRequirement(id: any, req: any) {
    const url = `${this.url}`;
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'setRequirement', item1: id, item2: req })
    .pipe(
      catchError(this.handleError('setRequirement', []))
    );
  }

  setWorkArea(id: any, workArea: string) {
    const url = `${this.url}`;
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'setWorkArea', item1: id, item2: workArea })
    .pipe(
      catchError(this.handleError('setWorkArea', []))
    );
  }

  confirmRequest(id: any) {
    const url = `${this.url}`;
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'confirmRequest', item1: id })
    .pipe(
      catchError(this.handleError('confirmRequest', []))
    );
  }

  getConfirmedShifts(site: string, date: string) {
    const url = `${this.url}`;
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({ headers: headers });
    return this.http.post<Position[]>(url, { token: localStorage.getItem('token'), function: 'getPositions', item1: site, item2: date })
    .pipe(
      catchError(this.handleError('getConfirmedShifts', []))
    );
  }

  updateStartAndEndTimeForPosition(startTime: String, endTime: String, insyncPositionId: number) {
    const url = baseAPI + '/insync/updateStartAndEndTimeForPosition';
    return this.http.put<any>(url, {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal',
      startTime,
      endTime,
      insyncPositionId,
    })
    .pipe(
      catchError(this.handleError('updateStartAndEndTimeForPosition'))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }

}
